import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import type { MainDataCreateRequest, MainDataResult } from "../types/mainData";

/** 直接新增并更新向量，禁止自动重发写请求。 */
export async function createMainData(itineraryId: string, request: MainDataCreateRequest, draftDemandId?: string): Promise<MainDataResult> {
  const response = await httpClient.post<ApiEnvelope<{
    outcome: "duplicate" | "created";
    entity_id: string;
    name: string;
  }>>(`/itineraries/${encodeURIComponent(itineraryId)}/main-data`, {
    kind: request.kind,
    name: request.name.trim(),
    province: request.province,
    city: request.city ?? "",
    stay_area_id: request.stayAreaId ?? null,
  }, { ...(draftDemandId ? { params: { draft_demand_id: draftDemandId } } : {}), timeout: 180_000, "axios-retry": { retries: 0 } });
  const raw = response.data.data;
  if (response.data.code !== "OK" || !raw || typeof raw.entity_id !== "string" || !raw.entity_id
    || typeof raw.name !== "string" || !raw.name
    || !["created", "duplicate"].includes(raw.outcome)) {
    throw new Error("新增结果未确认，请检查后重新提交");
  }
  return { outcome: raw.outcome, entityId: raw.entity_id, name: raw.name };
}
